module.exports = __webpack_public_path__ + "img/approval1.781a9669.png";